import React, { Component } from "react";
import VerificationForm from "../VerificationForm/VerificationForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SupportPage
Description : Componente que contienen el formulario de la pantalla Support 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class VerificationPage extends Component {
    render() {
        return (
            <div>
                <VerificationForm />
            </div>
        )
    }
}

export default VerificationPage;